import {
  Home,
  Users,
  Building2,
  FileText,
  CreditCard,
  LayoutDashboard,
  UserCircle,
  Calendar,
  Clock,
  DollarSign,
  FolderOpen,
  FileCheck,
  TrendingUp,
  ClipboardCheck,
  Shield,
} from 'lucide-react';

export const menuItems = {
  portal: [{ name: 'Dashboard', icon: Home, page: 'Portal' }],
  hris: [
    { name: 'Dashboard HRIS', icon: LayoutDashboard, page: 'HRISDashboard' },
    { name: 'Data Pegawai', icon: Users, page: 'EmployeeList' },
    { name: 'Struktur Organisasi', icon: Building2, page: 'OrganizationStructure' },
    { name: 'Punishment', icon: Shield, page: 'PunishmentList' },
    { name: 'Pengembangan SDM', icon: TrendingUp, page: 'EmployeeDevelopmentList' },
    { name: 'Pengadaan Karyawan', icon: UserCircle, page: 'RecruitmentList' },
    { name: 'Absensi', icon: Clock, page: 'AttendanceList' },
    { name: 'Cuti', icon: Calendar, page: 'LeaveList' },
    { name: 'KPI', icon: TrendingUp, page: 'KPIList' },
    { name: 'Penggajian', icon: DollarSign, page: 'PayrollList' },
    { name: 'Hak Akses Role', icon: Shield, page: 'RoleAccessManagement' },
  ],
  archive: [
    { name: 'Dashboard Arsip', icon: LayoutDashboard, page: 'ArchiveDashboard' },
    { name: 'Master Kategori', icon: Building2, page: 'ArchiveCategoryList' },
    { name: 'Master Jenis Dokumen', icon: FileText, page: 'DocumentTypeList' },
    { name: 'Semua Dokumen', icon: FolderOpen, page: 'DocumentList' },
    { name: 'Workflow Validasi', icon: FileCheck, page: 'DocumentValidationWorkflow' },
  ],
  debtor_legacy: [
    { name: '⚠️ LEGACY: Dashboard', icon: LayoutDashboard, page: 'DebtorDashboard' },
    { name: '⚠️ LEGACY: Data Debitur', icon: Users, page: 'DebtorList' },
  ],
  credit: [
    { name: 'Dashboard Kredit', icon: LayoutDashboard, page: 'CreditDashboard' },
    { name: 'Pengajuan Kredit', icon: FileText, page: 'CreditSubmissionForm' },
    { name: 'Daftar Aplikasi', icon: FileText, page: 'CreditApplicationList' },
    { name: 'Model Scoring', icon: ClipboardCheck, page: 'ScoringModelList' },
    { name: 'Approval', icon: CreditCard, page: 'ApprovalList' },
  ],
};

export const moduleLabels = {
  portal: 'Portal Utama',
  hris: 'HRIS',
  archive: 'Arsip Terintegrasi',
  debtor_legacy: 'Arsip Debitur (Legacy)',
  credit: 'Analisis Kredit',
};

export const moduleColors = {
  portal: 'bg-slate-700',
  hris: 'bg-emerald-600',
  archive: 'bg-purple-600',
  debtor_legacy: 'bg-amber-600',
  credit: 'bg-blue-600',
};

export function getActiveModule(currentPageName: string) {
  if (!currentPageName) {
    return 'portal';
  }

  const page = currentPageName.toLowerCase();

  // Check archive first (before credit, because ApprovalList is in credit module)
  // Explicitly check for ArchiveDashboard and other archive pages
  if (
    page === 'archivedashboard' ||
    page.startsWith('archive') ||
    (page.includes('document') && !page.includes('credit') && !page.includes('debtor'))
  ) {
    return 'archive';
  }
  // Check credit (including ApprovalList which has 'Approval' in name)
  if (
    page.includes('credit') ||
    page.includes('scoring') ||
    (page.includes('approval') && !page.includes('archive'))
  ) {
    return 'credit';
  }
  // Check HRIS
  if (
    page.includes('hris') ||
    page.includes('employee') ||
    page.includes('attendance') ||
    page.includes('leave') ||
    page.includes('kpi') ||
    page.includes('payroll') ||
    page.includes('department') ||
    page.includes('recruitment') ||
    page.includes('organization') ||
    page.includes('punishment') ||
    page.includes('employeedevelopment') ||
    page.includes('rbac') ||
    page.includes('rolepermission') ||
    page.includes('modulefeature') ||
    page.includes('approvalmatrix') ||
    page.includes('accesslog') ||
    page.includes('permissionsimulator') ||
    page.includes('roleaccess')
  ) {
    return 'hris';
  }
  // Check debtor legacy
  if (page.includes('debtor')) {
    return 'debtor_legacy';
  }
  return 'portal';
}
